<template>
  <div>Check...</div>
</template>

<script>
export default {
  data() {
    return {
      error: '',
      isLoaded: false,
    };
  },
  created() {
    const { token } = this.$route.params;
    if (!token) {
      this.$router.push({ path: '/' });
      return;
    }

    this.$store.dispatch('checkToken', token)
      .finally(() => {
        this.$router.push({ path: '/' });
      });
  },
};
</script>
